import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

export function getAppName(
  config = { isFree: false }
): 'Analyst Studio' | 'Analyst Studio (FREE)' | 'Mode' | 'Mode Studio' {
  return ThoughtspotIntegrationService.currOrgIntegrated()
    ? `Analyst Studio${config.isFree ? ` (FREE)` : ``}`
    : `Mode${config.isFree ? ` Studio` : ``}`;
}

export function getSupportEmail(): 'analyst-studio@thoughtspot.com' | 'support@modeanalytics.com' {
  return ThoughtspotIntegrationService.currOrgIntegrated()
    ? 'analyst-studio@thoughtspot.com'
    : 'support@modeanalytics.com';
}
